// CSS imports
import './styles/variables.css';
import './styles/reset.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/components/sidebar.css';
import './styles/components/panel.css';
import './styles/components/inputs.css';
import './styles/components/status.css';
import './styles/components/toast.css';
import './styles/components/modal.css';
import './styles/components/broker-selector.css';

// App imports
import { createAppShell } from './app.js';
import { Router } from './router/router.js';
import { createSidebar } from './components/sidebar.js';
import { registerBroker, switchBroker } from './services/broker/broker-registry.js';
import { createTradierAdapter } from './services/broker/tradier/tradier-adapter.js';
import { createIbkrAdapter } from './services/broker/ibkr/ibkr-adapter.js';
import { storage } from './services/storage.js';
import { hydrateFromCloud } from './services/cloud-sync.js';

const ENABLE_IBKR = String(import.meta.env.VITE_ENABLE_IBKR || '').toLowerCase() === 'true';

const routes = [
  { id: 'chart', label: 'Stock Chart', icon: 'chart' },
  { id: 'options', label: 'Options Visualizer', icon: 'layers' },
  { id: 'portfolio', label: 'Portfolio', icon: 'portfolio' },
  { id: 'daytrader', label: 'Day Trader', icon: 'ladder' },
  { id: 'meme-scanner', label: 'Momentum Scanner', icon: 'scan' },
  { id: 'about', label: 'About', icon: 'about' }
];

registerBroker('tradier', createTradierAdapter);
if (ENABLE_IBKR) {
  registerBroker('ibkr', createIbkrAdapter);
}
switchBroker(storage.getSelectedBroker());

const { sidebarContainer, contentContainer } = createAppShell();
const sidebarEl = document.getElementById('app-sidebar');
const hamburgerBtn = document.getElementById('hamburger-btn');
const sidebarBackdrop = document.getElementById('sidebar-backdrop');

const router = new Router(contentContainer);

router.register('options', () => import('./pages/options/options-page.js'));
router.register('chart', () => import('./pages/chart/chart-page.js'));
router.register('daytrader', () => import('./pages/daytrader/daytrader-page.js'));
router.register('meme-scanner', () => import('./pages/meme-scanner/meme-page.js'));
router.register('about', () => import('./pages/about/about-page.js'));
router.register('portfolio', () => import('./pages/portfolio/portfolio-page.js'));

function openSidebar() {
  sidebarEl.classList.add('open');
  sidebarBackdrop.classList.add('visible');
  hamburgerBtn.setAttribute('aria-expanded', 'true');
  document.body.classList.add('sidebar-open');
}

function closeSidebar() {
  sidebarEl.classList.remove('open');
  sidebarBackdrop.classList.remove('visible');
  hamburgerBtn.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('sidebar-open');
}

const sidebar = createSidebar(routes, (routeId) => {
  router.navigate(routeId);
  closeSidebar();
});
sidebarContainer.appendChild(sidebar.el);

router.onRouteChange((hash) => sidebar.setActiveRoute(hash));

hamburgerBtn.addEventListener('click', () => {
  if (sidebarEl.classList.contains('open')) {
    closeSidebar();
  } else {
    openSidebar();
  }
});

sidebarBackdrop.addEventListener('click', closeSidebar);

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeSidebar();
});

router.start();
hydrateFromCloud(storage); // background sync — never blocks render
